import { SectionButtonRounded } from 'lib/SectionButton/SectionButton.types';
import { TargetKey } from '../../types';
import { FormatTargetsProps } from './formatTargets.types';

export interface TargetsButtonProps extends FormatTargetsProps {
  lineId?: string;
  isActive: boolean;
  onClear: (key: TargetKey) => void;
  onTargetClick?: (key: TargetKey) => void;
  isDisabled?: boolean;
  onShowMoreMenuClick?: () => void;
  areDealInfoMandatoryFieldsFilled: boolean;
  isRequired?: boolean;
  overrideRequiredStates?: {
    budgetRequired?: boolean;
    framesRequired?: boolean;
    impressionsRequired?: boolean;
  };
}

export const TARGET_KEY_TO_BORDER_RADIUS_MAPPING = {
  budget: SectionButtonRounded.ROUNDED_TOP,
  frames: SectionButtonRounded.NONE,
  impressions: SectionButtonRounded.ROUNDED_BOTTOM,
};
